import React from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";

const TopSection = ({ image, typeOfBuilding, projectType, title, status }) => (
  <Box
    sx={{
      position: "relative",
      minHeight: { xs: 390, sm: 500, md: 650 },
      display: "flex",
      alignItems: "flex-end",
      overflow: "hidden",
      backgroundColor: "#292720",
    }}
  >
    <Box
      component="img"
      src={image}
      alt={title || "Homely construction project"}
      sx={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
      }}
    />
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        background:
          "linear-gradient(90deg, rgba(20,19,16,0.68), rgba(20,19,16,0.04) 90%), linear-gradient(0deg, rgba(20,19,16,0.7), transparent 70%)",
      }}
    />
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.75, ease: [0.22, 1, 0.36, 1] }}
      style={{
        position: "relative",
        zIndex: 1,
        width: "100%",
        padding: "clamp(28px, 7vw, 88px)",
      }}
    >
      <Typography
        sx={{
          mb: 2,
          color: "#e2c796",
          fontSize: "0.68rem",
          fontWeight: 600,
          letterSpacing: "0.18em",
          textTransform: "uppercase",
        }}
      >
        {[projectType, typeOfBuilding].filter(Boolean).join(" · ") || "HOMELY PROJECT"}
        {status ? `  /  ${status}` : ""}
      </Typography>
      <Typography
        component="h1"
        sx={{
          maxWidth: 900,
          color: "white",
          fontFamily: 'Georgia, "Times New Roman", serif',
          fontSize: { xs: "2.7rem", md: "5.3rem" },
          lineHeight: 1.05,
        }}
      >
        {title || typeOfBuilding || "Built with care"}
      </Typography>
    </motion.div>
  </Box>
);

export default TopSection;
